import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isFunction } from 'lodash-es';

import SimpleCheckbox from './SimpleCheckbox';
import SimpleDropdown from '../Dropdowns/SimpleDropdown';

const takeIds = (items, itemKey) => {
  if (itemKey) {
    return isFunction(itemKey) ? items.map(itemKey) : items.map(item => item[itemKey]);
  }
  return items;
};

const DiverseSelection = ({
  id = 'diverse-selection',
  menuOptions,
  allKey = 'all',
  noneKey = 'none',
  selected,
  selectableItems,
  itemKey,
  disabled = false,
  menuClassName,
  onChange,
}) => {
  const selectedIds = takeIds(selected, itemKey);
  const itemsIds = takeIds(selectableItems, itemKey);

  const unselectedCount = new Set([...selectedIds, ...itemsIds]).size - selectedIds.length;
  const allSelected = itemsIds.length > 0 && unselectedCount === 0;
  const anySelected = itemsIds.length > unselectedCount;

  const isSelected = allSelected;
  const isIndeterminateState = anySelected && !isSelected;

  const filtersList = menuOptions.reduce((result, item) => ({
    ...result,
    [item.value]: item.filterBy,
  }), {});


  const handleSelection = (checkedKey) => {
    const filterBy = filtersList[checkedKey];

    const defaultResult = ({
      [allKey]: selectableItems,
      [noneKey]: [],
    }[checkedKey]) || selected;

    onChange(filterBy ? selectableItems.filter(filterBy) : defaultResult, { kind: checkedKey });
  };

  const handleCheckboxChange = (isChecked) => {
    handleSelection(isChecked ? allKey : noneKey);
  };

  return (
    <div className="diverse-selection">
      <SimpleCheckbox
        id={id}
        size="lg"
        checked={isSelected}
        indeterminate={isIndeterminateState}
        withHoverEffect
        disabled={disabled}
        onChange={handleCheckboxChange}
      />
      <SimpleDropdown
        options={menuOptions}
        size="lg"
        disabled={disabled}
        className={cx('diverse-selection-menu', menuClassName)}
        onChange={handleSelection}
      />
    </div>
  );
};

DiverseSelection.propTypes = {
  id: T.string,
  menuOptions: T.arrayOf(
    T.shape({
      value: T.string,
      label: T.node,
      disabled: T.bool,
      filterBy: T.func,
    }),
  ).isRequired,
  allKey: T.string,
  noneKey: T.string,
  selected: T.array.isRequired,
  selectableItems: T.array.isRequired, // Should have the same structure as `selected`
  itemKey: T.oneOfType([T.string, T.func]), // Should be used if `selected` is an array of objects,
  disabled: T.bool,
  menuClassName: T.string,
  onChange: T.func.isRequired,
};

export default DiverseSelection;
